"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useButton_unstable", {
    enumerable: true,
    get: ()=>useButton_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactAria = require("@fluentui/react-aria");
const _reactUtilities = require("@fluentui/react-utilities");
const _buttonContext = require("../../contexts/ButtonContext");
const useButton_unstable = (props, ref)=>{
    const { size: contextSize  } = (0, _buttonContext.useButtonContext)();
    const { appearance ='secondary' , as ='button' , disabled =false , disabledFocusable =false , icon , iconPosition ='before' , shape ='rounded' , size =contextSize !== null && contextSize !== void 0 ? contextSize : 'medium'  } = props;
    const iconShorthand = (0, _reactUtilities.resolveShorthand)(icon);
    return {
        // Props passed at the top-level
        appearance,
        disabled,
        disabledFocusable,
        iconPosition,
        shape,
        size,
        // State calculated from a set of props
        iconOnly: Boolean((iconShorthand === null || iconShorthand === void 0 ? void 0 : iconShorthand.children) && !props.children),
        // Slots definition
        components: {
            root: 'button',
            icon: 'span'
        },
        root: (0, _reactUtilities.getNativeElementProps)(as, (0, _reactAria.useARIAButtonShorthand)(props, {
            required: true,
            defaultProps: {
                ref: ref,
                type: 'button'
            }
        })),
        icon: iconShorthand
    };
}; //# sourceMappingURL=useButton.js.map

//# sourceMappingURL=useButton.js.map